import * as React from 'react'
import { SVGProps } from 'react'
const SvgArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 18 18" {...props}>
    <path d="M9 1.72 3.218 7.5l.53.53 4.875-4.875v12.97h.75V3.155L14.25 8.03l.53-.53L9 1.72Z" />
  </svg>
)
export default SvgArrowUp
